import { useQueryClient } from '@tanstack/react-query';

import { Button, Col, Modal } from 'antd';

// import CreateProductForm from 'common/components/product-add/CreateProductForm';
import SelfLoadedProductForm from 'common/components/product-add/SelfLoadedProductForm';
import CreateProductModalFooter from 'common/components/product-add/CreateProductModalFooter';

// import useCreateProduct from 'hooks/createProductHooks';
import useCreateProduct from 'hooks/selfLoadedProductHooks';

import { useIntl } from 'react-intl';
import messages from 'i18n/messages/product';
import { ERROR_FIELD_NAME_COLLECTION } from './constants';
import { useValidatePrimaryFieldsForActiveProduct } from 'hooks/useValidateSelfLoadedProduct';
import Form from 'common/components/form/Form';
import { isUnitPackageLevel } from 'common/components/product-add/components/utils/validation';
import { validateActiveProductKey } from 'pages/home/ribbon/components/sections/product/components/make-product-active/hooks';

const UpdateMinimumRequirementProductField = (props) => {
  const intl = useIntl();

  const { item, visible, setVisible, productDetail } = props;

  const queryClient = useQueryClient();

  const reloadPage = () => {};

  const handleCancel = () => {
    setVisible(false);
  };

  const { submitForm, formLoading, resetFormState, ...createProductFormProps } =
    useCreateProduct({
      modalVisible: visible,
      productDetail,
      reloadPage,
      isEdit: Boolean(productDetail?.productId),
      callApiCallback: handleCancel,
      productId: productDetail?.productId,
    });

  const { form, setValidateErrors, getFormPayload } = createProductFormProps;
  const packageLevel = Form.useWatch('packageLevel', form);
  const isUnit = isUnitPackageLevel(packageLevel);

  const status = Form.useWatch('status', form);
  const isActiveStatus = status?.toLowerCase() === 'active';

  const validatePrimaryFieldsMutation =
    useValidatePrimaryFieldsForActiveProduct({
      form,
      isUnit,
      setValidateErrors,
      isActiveStatus,
    });

  const isValidating = validatePrimaryFieldsMutation.isLoading;

  const handleOk = () => {
    submitForm();
  };

  const errorFieldNameCollection = {
    product_Brand: ERROR_FIELD_NAME_COLLECTION.BRAND,
    product_UpcGtin: ERROR_FIELD_NAME_COLLECTION.AT_LEAST_GTIN_UPC,
  };

  const errorInfo = [
    {
      name: [errorFieldNameCollection[item.id]],
      errors: [intl.formatMessage(messages.minimumRequirementMessage)],
    },
  ];

  return productDetail?.productId ? (
    <Modal
      visible={visible}
      width={'85vw'}
      centered
      wrapClassName='styled-modal document-modal'
      title='Minimum Requirement'
      onCancel={handleCancel}
      footer={
        <CreateProductModalFooter
          onCancel={handleCancel}
          onOk={handleOk}
          okLoading={formLoading}
        >
          <Col>
            <Button
              onClick={async () => {
                if (getFormPayload) {
                  const payload = getFormPayload();
                  await validatePrimaryFieldsMutation.mutateAsync(payload);

                  await queryClient.invalidateQueries({
                    queryKey: validateActiveProductKey(
                      productDetail?.productId ? [productDetail?.productId] : []
                    ),
                  });
                }
              }}
              loading={isValidating}
            >
              Validate Product
            </Button>
          </Col>
        </CreateProductModalFooter>
      }
    >
      <SelfLoadedProductForm
        {...createProductFormProps}
        errorInfo={errorInfo}
      />
    </Modal>
  ) : null;
};

export default UpdateMinimumRequirementProductField;
